<template>
  <div class="general">
    <div class="title">通用</div>
    <div class="content">
      <div class="item">
        <div class="item-top">清理缓存：</div>
        <div class="item-bottom">
          <div class="btn" @click="clearCache">一键清理缓存</div>
        </div>
      </div>
      <div class="item">
        <div class="item-top">常用菜单顶部展示：</div>
        <div class="item-bottom">
          <el-radio :value="menuTopDisplayed" :label="true" @change="changeMenuTopDisplayed">启用</el-radio>
          <el-radio :value="menuTopDisplayed" :label="false" @change="changeMenuTopDisplayed">停用</el-radio>
        </div>
      </div>
      <div class="item">
        <div class="item-top">菜单栏弹出方式：</div>
        <div class="item-bottom">
          <el-radio :value="menuPopUpMethod" label="MOUSE_CLICK" @change="changeMenuPopUpMethod">鼠标点击</el-radio>
          <el-radio :value="menuPopUpMethod" label="MOUSE_SLIDING" @change="changeMenuPopUpMethod">鼠标滑动</el-radio>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUserGeneralSettingsFind, apiUserGeneralSettingsUpdateByUserId } from "@/api/user"
export default {
  name: "General",
  data() {
    return {
      menuPopUpMethod: "MOUSE_CLICK",
      menuTopDisplayed: true
    }
  },
  created() {
    this.getUserGeneralSettingsFind()
  },
  methods: {
    changeMenuTopDisplayed(status) {
      this.$confirm(`${status ? "停用" : "启用"}常用菜单顶部展示，需刷新页面后生效，是否立即刷新？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.updateUserGenera("menuTopDisplayed", status)
      })
    },
    changeMenuPopUpMethod(status) {
      this.$confirm(`菜单栏弹出方式更新为鼠标${status === "MOUSE_SLIDING" ? "点击" : "滑动"}，需刷新页面后生效，是否立即刷新？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.updateUserGenera("menuPopUpMethod", status)
      })
    },
    // 更新通用设置
    async updateUserGenera(type = "menuTopDisplayed", status) {
      const { code } = await apiUserGeneralSettingsUpdateByUserId({
        menuTopDisplayed: type === "menuTopDisplayed" ? !status : this.menuTopDisplayed,
        menuPopUpMethod: type === "menuPopUpMethod" ? (status === "MOUSE_CLICK" ? "MOUSE_SLIDING" : "MOUSE_CLICK") : this.menuPopUpMethod
      })
      if (code != 0) return
      if (type === "menuPopUpMethod") {
        this.menuPopUpMethod = status === "MOUSE_CLICK" ? "MOUSE_SLIDING" : "MOUSE_CLICK"
      } else if (type === "menuTopDisplayed") {
        this.menuTopDisplayed = !status
        if (status) {
          this.$store.commit("tagsView/CHANGE_FAVTOPSHOW", "")
        } else {
          this.$store.commit("tagsView/CHANGE_FAVTOPSHOW", "true")
        }
      }
      this.$router.go(0)
    },
    // 获取通用设置
    async getUserGeneralSettingsFind() {
      const { code, data = {} } = await apiUserGeneralSettingsFind()
      if (code != 0) return
      this.menuTopDisplayed = !!data.menuTopDisplayed ?? localStorage.getItem("favTopShow") == "true"
      this.menuPopUpMethod = data.menuPopUpMethod || "MOUSE_CLICK"
    },
    async clearCache() {
      // 网易sdk,js缓存溢出删除indexDB数据库
      const dbs = await indexedDB.databases()
      let deletDbName = ""
      dbs.forEach(item => {
        if (item.name.indexOf("nim-log-") > -1) {
          deletDbName = item.name
        }
      })
      const request = window.indexedDB.open(deletDbName, 1)

      request.onsuccess = event => {
        const db = event.target.result
        // 关闭数据库连接
        db.close()

        // 删除数据库
        const deleteRequest = window.indexedDB.deleteDatabase(deletDbName)
        this.$message.success("当前页面数据库清理完成")
        deleteRequest.onsuccess = function () {
          console.log(deletDbName + ":数据库删除成功")
        }

        deleteRequest.onerror = function (event) {
          console.error(deletDbName + ":数据库删除失败:", event.target.error)
        }
      }

      request.onerror = function (event) {
        console.error("打开数据库失败:", event.target.error)
      }
      // 检测用户的设备是否是Windows系统
      // 物理缓存删除
      if (/windows|win32/i.test(navigator.userAgent)) {
        // 检测用户的浏览器是否能使用universalLink
        let openApp = false
        const userAgent = navigator.userAgent
        // 判断是否 Firefox浏览器
        if (userAgent.indexOf("Firefox") > -1) {
          openApp = true
        }
        // 判断是否 Chrome浏览器
        if (userAgent.indexOf("Chrome") > -1) {
          openApp = true
        }
        // 判断是否 Edge浏览器
        if (userAgent.indexOf("Edg") > -1) {
          openApp = true
        }
        if (openApp) {
          try {
            window.location.href = "universalLink://"
          } catch (err) {
            this.$message.warning("请先安装该软件")
            console.log(err)
          }
        } else {
          this.$message.warning("您的浏览器不支持自动打开该工具，请前往D盘打开memreduct.exe！")
          this.$notify.warning({
            title: "提示",
            content: "推荐使用Chrome浏览器！",
            placement: "bottom-right",
            duration: 3000
          })
        }
      } else {
        this.$message.warning("您的设备暂不支持运行小程序，请在Windows电脑上进行操作！")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.general {
  width: 100%;
  height: 100%;
  padding: 24px 0 0 24px;
  display: flex;
  flex-direction: column;

  .title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    line-height: 19px;
  }

  .content {
    .item {
      margin-top: 24px;

      .item-top {
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 16px;
      }

      .item-bottom {
        margin-top: 12px;

        .btn {
          width: 200px;
          height: 32px;
          background: #f0f2f5;
          border-radius: 4px 4px 4px 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 500;
          font-size: 14px;
          color: #666666;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep {
  .el-radio__inner::after {
    width: 7px;
    height: 7px;
    background: #3296fa;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background: #fff;
  }
}
</style>
